import "core-js/modules/es6.reflect.construct.js";
import _classCallCheck from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js";
import _createClass from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/createClass.js";
import _get from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/get.js";
import _inherits from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/inherits.js";
import _possibleConstructorReturn from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js";
import _getPrototypeOf from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js";
import _defineProperty from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js";
import "core-js/modules/es6.array.find.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.promise.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

// User Model
import VuexORM from '@vuex-orm/core';
import Entry from "./Entry";
import Phase from "./Phase";
import Account from "./Account";
import User from "./User";
import ProjectUser from "./ProjectUser";
import Group from "./Group";
import Client from "./Client";
import Budget from "./Budget";
import ProjectGroup from "./ProjectGroup";
import TagList from "./TagList";
import Tag from "./Tag";
import ProjectTagList from "./ProjectTagList";
import ProjectTag from "./ProjectTag";
import TodoList from "./TodoList";
import Integration from "./Integration";
import { BILLING_TYPE } from 'src/boot/constants';

var Project = /*#__PURE__*/function (_VuexORM$Model) {
  _inherits(Project, _VuexORM$Model);

  var _super = _createSuper(Project);

  function Project() {
    _classCallCheck(this, Project);

    return _super.apply(this, arguments);
  }

  _createClass(Project, [{
    key: "budget",
    get: function get() {
      return Budget.query().where('project_id', this.project_id).where('user_id', null).where('task_id', null).where('tag_list_id', null).where('tag_id', null).where('is_active', 1).first();
    }
  }, {
    key: "intermediate",
    value: function intermediate(key, entityId) {
      switch (key) {
        case 'user':
          return ProjectUser.find([this.project_id, entityId]);

        case 'group':
          return ProjectGroup.find([this.project_id, entityId]);

        default:
          return null;
      }
    }
  }, {
    key: "canEdit",
    value: function canEdit(userId) {
      var userRelationship = ProjectUser.find([this.project_id, userId]);
      var user = User.find(userId);

      if (user.account_id === this.account_id && user.is_admin) {
        return 1;
      }

      return userRelationship ? userRelationship.is_pm : 0;
    }
  }, {
    key: "active",
    get: function get() {
      return !!this.is_active;
    }
  }], [{
    key: "entity",
    get: // This is the name used as module name of the Vuex Store.
    function get() {
      return 'projects';
    }
  }, {
    key: "primaryKey",
    get: function get() {
      return 'project_id';
    }
  }, {
    key: "apiConfig",
    get: function get() {
      return {
        dataKey: 'data',
        actions: {
          fetchById: function fetchById(id) {
            var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            return this.get("/projects/".concat(id), {
              params: data
            }).then(function (result) {
              return result;
            });
          }
        }
      };
    }
  }, {
    key: "insertOrUpdate",
    value: function insertOrUpdate(_ref) {
      var data = _ref.data;
      var isUserPivotIncluded = false,
          isGroupPivotIncluded = false,
          isTagListPivotIncluded = false;

      if (Array.isArray(data)) {
        data.forEach(function (item) {
          if (item.users && item.users.length) {
            isUserPivotIncluded = true;
          }

          if (item.groups && item.groups.length) {
            isGroupPivotIncluded = true;
          }

          if (item.tag_lists && item.tag_lists.length) {
            isTagListPivotIncluded = true;
          }
        });
        var userPivotData = [];

        if (isUserPivotIncluded) {
          // check if pivot table is present
          userPivotData = data.map(function (project) {
            return project.users.map(function (user) {
              return user.pivot;
            });
          }).flat();
        }

        var groupPivotData = [];

        if (isGroupPivotIncluded) {
          // check if pivot table is present
          groupPivotData = data.map(function (project) {
            return project.groups.map(function (group) {
              return group.pivot;
            });
          }).flat();
        }

        var tagListPivotData = [];

        if (isTagListPivotIncluded) {
          // check if pivot table is present
          tagListPivotData = data.map(function (project) {
            return project.tag_lists.map(function (group) {
              return group.pivot;
            });
          }).flat();
        }
      }

      return Promise.all([_get(_getPrototypeOf(Project), "insertOrUpdate", this).call(this, {
        data: data
      }), isUserPivotIncluded ? ProjectUser.insertOrUpdate({
        data: userPivotData
      }) : Promise.resolve(), isGroupPivotIncluded ? ProjectGroup.insertOrUpdate({
        data: groupPivotData
      }) : Promise.resolve(), isTagListPivotIncluded ? ProjectTagList.insertOrUpdate({
        data: tagListPivotData
      }) : Promise.resolve()]).then(function (results) {
        return results[0];
      });
    } // List of all fields (schema) of the post model. `this.attr` is used
    // for the generic field type. The argument is the default value.

  }, {
    key: "fields",
    value: function fields() {
      return {
        // general info
        project_id: this.attr(null),
        name: this.attr(null),
        lower_name: this.attr(null),
        color: this.attr(null),
        description: this.attr(''),
        hourly_rate: this.number(null),
        integration_code: this.attr(null),
        integration_int1: this.attr(null),
        last_integration_sync: this.attr(null),
        lastedit_datetime: this.attr(null),
        lastedit_user_id: this.attr(null),
        lastedit_user_name: this.attr(null),
        project_type: this.attr('phases'),
        // flags
        is_syncing: this.attr(0),
        is_active: this.attr(1),
        is_billable: this.attr(0),
        is_public: this.attr(0),
        is_favorited: this.attr(0),
        tag_usage: this.attr('ALL_TAGS'),
        requires_tags: this.attr(0),
        api_only: this.attr(0),
        is_demo: this.attr(0),
        // billing info
        billing_type: this.attr(BILLING_TYPE.NOT_BILLABLE),
        // budget info
        budget_is_active: this.boolean(false),
        budget_minutes: this.number(0),
        budget_percentage: this.number(0),
        budget_total_minutes: this.number(0),
        budget_total_revenue: this.number(0),
        budget_total_cost: this.number(0),
        budget_recurrence: this.number(0),
        // totals
        total_time: this.number(null),
        billable_time: this.number(null),
        unbillable_time: this.number(null),
        billed_time: this.number(null),
        unbilled_time: this.number(null),
        total_costs: this.number(null),
        billed_costs: this.number(null),
        unbilled_costs: this.number(null),
        billed_money: this.number(null),
        unbilled_money: this.number(null),
        total_profits: this.number(null),
        users_count: this.number(0),
        // relationship ids
        account_id: this.attr(null),
        client_id: this.attr(null),
        // relationship objects
        account: this.belongsTo(Account, 'account_id'),
        entries: this.hasMany(Entry, 'project_id', 'project_id'),
        phases: this.hasMany(Phase, 'project_id'),
        users: this.belongsToMany(User, ProjectUser, 'project_id', 'user_id', 'project_id', 'user_id'),
        groups: this.belongsToMany(Group, ProjectGroup, 'project_id', 'group_id'),
        client: this.belongsTo(Client, 'client_id'),
        budgets: this.hasMany(Budget, 'project_id'),
        tag_lists: this.belongsToMany(TagList, ProjectTagList, 'project_id', 'tag_list_id'),
        tags: this.belongsToMany(Tag, ProjectTag, 'project_id', 'tag_id'),
        todo_lists: this.hasMany(TodoList, 'project_id', 'todo_list_id'),
        integration: this.hasOne(Integration, 'integration_code'),
        has_todos: this.attr(0),
        fixed_fee: this.attr(0)
      };
    }
  }, {
    key: "getLastUsedData",
    value: function getLastUsedData() {
      var entityIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var projectQuery = Project.query().where('is_active', 1).whereHas('users', function (query) {
        query.where('user_id', entityIds.userId);
      }).with('users', function (query) {
        query.where('user_id', entityIds.userId);
      });

      if (entityIds.projectId) {
        projectQuery.where('project_id', entityIds.projectId);
      }

      if (entityIds.clientId) {
        projectQuery.where('client_id', entityIds.clientId);
      }

      var projects = projectQuery.get();
      var lastUserData = {
        usedTime: null,
        projectId: -1,
        phaseId: -1
      };
      projects.forEach(function (project) {
        project.users[0].pivot = project.users[0].intermediate('project', project.project_id);

        if (project.users[0].pivot.is_member && (!lastUserData.usedTime || lastUserData.usedTime < project.users[0].pivot.last_used)) {
          lastUserData.usedTime = project.users[0].pivot.last_used;
          lastUserData.projectId = project.project_id; // check if last used task is still open

          var phaseId = project.users[0].pivot.last_used_task_id;

          if (phaseId > 0) {
            var phase = Phase.find(phaseId);

            if (phase && phase.is_open) {
              lastUserData.phaseId = phaseId;
            }
          } // lastUserData.phaseId = project.users[0].pivot.last_used_task_id > 0 ? project.users[0].pivot.last_used_task_id : -1

        }
      });
      return lastUserData;
    }
  }, {
    key: "$isUserPM",
    value: function $isUserPM(projectId, userId) {
      var userRelationship = ProjectUser.find([projectId, userId]);
      return userRelationship ? userRelationship.is_pm : 0;
    }
  }, {
    key: "$isUserMember",
    value: function $isUserMember(projectId, userId) {
      var userRelationship = ProjectUser.find([projectId, userId]);
      return userRelationship ? userRelationship.is_member : 0;
    }
  }, {
    key: "$canEdit",
    value: function $canEdit(projectId, userId) {
      var userRelationship = ProjectUser.find([projectId, userId]);
      var project = Project.find(projectId);
      var user = User.find(userId);

      if (project && user && user.account_id === project.account_id && user.is_admin) {
        return 1;
      }

      return userRelationship ? userRelationship.is_pm : 0;
    }
  }]);

  return Project;
}(VuexORM.Model);

_defineProperty(Project, "state", {
  pending: false,
  lastSync: null,
  count: 0
});

export { Project as default };